import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, MessageSquare, PenTool, Sparkles, HeartHandshake } from "lucide-react";

const ProcessSection = () => {
  const steps = [
    {
      icon: MessageSquare,
      number: "01",
      title: "Free Consultation",
      description: "Tell us your vision for luxury home or commercial organization in Michigan."
    },
    {
      icon: PenTool,
      number: "02", 
      title: "Custom Design Plan",
      description: "We craft a bespoke strategy for your unique space."
    },
    {
      icon: Sparkles,
      number: "03",
      title: "Seamless Transformation", 
      description: "Our team executes with precision, creating your dream space."
    },
    {
      icon: HeartHandshake,
      number: "04",
      title: "Ongoing Support",
      description: "Maintain elegance with our exclusive maintenance plans."
    }
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-6">
            Our Proven Process for Clutter-Free Spaces
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            A seamless journey from consultation to transformation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <Card key={index} className="text-center border-border hover:shadow-lg transition-all duration-300 bg-background relative">
              <CardContent className="p-8">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-primary text-primary-foreground rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold">
                  {step.number}
                </div>
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6 mt-4">
                  <step.icon className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-lg font-semibold mb-4 text-balance">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {step.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;